window.addEventListener('alpine:init', () => {
  function productForm(data = {}) {
    return {
      ...data,

      refs: {
        ...this.refs,
        optionInputAll: this.$el.querySelectorAll('[x-ref="optionInput"]')
      },

      get formData() {
        var formData = new FormData(this.$el);

        formData.set('sections', this.$store.cart.sectionIds);

        return formData;
      },

      init() {
        this.onSelectedOptionsChange = this.onSelectedOptionsChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.selectedOptionValues = this.getSelectedOptionValues();

        this.$el.addEventListener('change', this.onSelectedOptionsChange);
        this.$el.addEventListener('submit', this.onSubmit);
      },

      destroy() {
        this.$el.removeEventListener('change', this.onSelectedOptionsChange);
        this.$el.removeEventListener('submit', this.onSubmit);
      },

      onSelectedOptionsChange(event) {
        if ([...this.refs.optionInputAll].includes(event.target)) {
          this.selectedOptionNames = this.getSelectedOptionNames();
          this.selectedOptionValues = this.getSelectedOptionValues();

          dispatchEvent(new CustomEvent('productformselectedoptionschange', {
            detail: {
              selectedOptionValues: this.selectedOptionValues
            }
          }));
        }
      },

      getSelectedOptionInputEls() {
        return [...this.refs.optionInputAll].filter((optionInputEl) => optionInputEl.checked);
      },

      getSelectedOptionNames() {
        return this.getSelectedOptionInputEls().map((optionInputEl) => optionInputEl.value);
      },

      getSelectedOptionValues() {
        return this.getSelectedOptionInputEls().map((optionInputEl) => +(optionInputEl.dataset.optionValueId));
      },

      onSubmit(event) {
        event.preventDefault();

        if (this.isLoading) return;

        dispatchEvent(new CustomEvent('productformsubmitstart'));
        dispatchEvent(new CustomEvent('cartchangestart'));

        this.isLoading = true;

        var fetchUrl = this.$el.action;

        var fetchOptions = {
          method: this.$el.method,
          body: this.formData,
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              return res.text().then((err) => { throw new Error(err) });
            }

            return res.json();
          })
          .then((res) => {
            dispatchEvent(new CustomEvent('productformsubmitsuccess', { detail: { res } }));
            dispatchEvent(new CustomEvent('cartchangesuccess', { detail: { res } }));
          })
          .catch((err) => {
            dispatchEvent(new CustomEvent('productformsubmiterror', { detail: { err } }));
            dispatchEvent(new CustomEvent('cartchangeerror', { detail: { err } }));
            console.log(err);
          })
          .finally(() => {
            dispatchEvent(new CustomEvent('productformsubmitend'));
            dispatchEvent(new CustomEvent('cartchangeend'));
            this.isLoading = false;
          });
      }
    };
  };

  Alpine.data('productForm', productForm);
});
